import Settings from 'configs/Settings';
import { isObject } from 'helpers/Object';
import isEmpty from 'lodash/isEmpty';
import { AuthService } from 'modules/auth';
import { FileService } from 'modules/file';
import { UiService } from 'modules/ui';

import './WebinarApi';

import Request, { axios } from '@hotmart/request';

export const GET_WEBINARS_URL = `${Settings.api.live}/v1/schedule/find`;
export const GET_TOGGLE_CLUBLIVE = `${Settings.api.live}/v1/toggle/club-live`;
export const PAGE_TYPE = 'WEBINAR';

const DEFAULT_SIZE = 9999;

class WebinarService {
  // #region actions
  getWebinars({
    completed = false,
    page = 0,
    size = DEFAULT_SIZE,
    sort = 'LIVE_START_AT'
  }) {
    return axios.get(GET_WEBINARS_URL, {
      params: { completed, page, size, sort },

      headers: {
        Authorization: `Bearer ${AuthService.token}`
      }
    });
  }

  async getById(id) {
    if (!id) {
      return;
    }

    let response = null;
    let thumbnail = null;

    try {
      response = await Request('webinar.get', { id });
      [thumbnail] = (await FileService.fetchPageBackgroundImg(id)) || [];
    } catch (error) {
      this.handleError(error);
    }

    return this.formatResponseVO({ ...response, thumbnail });
  }

  async create(fields) {
    if (!fields || isEmpty(fields)) {
      return;
    }

    let response = null;

    try {
      const requestVO = this.formatRequestVO(fields);

      response = await Request('webinar.create', requestVO);

      UiService.setAlertSuccess('done');

      return response;
    } catch (error) {
      this.handleError(error);
    }

    return response;
  }

  async update(fields) {
    if (!fields || isEmpty(fields)) {
      return;
    }

    let response = null;

    try {
      const requestVO = this.formatRequestVO(fields);

      await Request('webinar.update', {
        ...requestVO,
        id: fields.id
      });

      UiService.setAlertSuccess('done');

      response = true;
    } catch (error) {
      this.handleError(error);

      response = false;
    }

    return response;
  }

  // #endregion

  // #region helpers
  formatRequestVO({ id, moduleId, name, webinar, thumbnail }) {
    return {
      ...(thumbnail && { backgroundImageId: thumbnail && thumbnail.id }),
      webinarKey: webinar,
      page: {
        ...{ id },
        moduleId,
        name,
        type: PAGE_TYPE
      }
    };
  }

  formatResponseVO({ page: { id, name, published }, thumbnail, webinarKey }) {
    return {
      id,
      name,
      webinarKey,
      published,
      thumbnail
    };
  }

  handleError(error = {}) {
    const { data } = error;
    const invalidHashError =
      isObject(data) && data.errorCode && data.errorCode === '0007';

    if (invalidHashError) {
      window.h.replace('new', { pageId: 'new' });
    }

    UiService.handleError(error);
  }
  // #endregion
}

export default new WebinarService();
